import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import ReactTimeAgo from 'react-timeago';
import esStrings from 'react-timeago/lib/language-strings/es';
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter';

import { formatFullDate } from '@ts-core/utils/dateFormatters';

const formatter = buildFormatter(esStrings);

const TimeAgo = (props) => {
  const { date, ...others } = props;

  if (!date) {
    return <span />;
  }

  const createdAt = moment(date);
  const timeAgo = moment().diff(createdAt, 'hours');

  if (timeAgo >= 24) {
    return <span>{formatFullDate(createdAt)}</span>;
  }

  return <ReactTimeAgo formatter={formatter} date={date} {...others} />;
};

TimeAgo.propTypes = {
  date: PropTypes.string,
};

TimeAgo.defaultProps = {
  date: undefined,
};

export default TimeAgo;
